import * as types from "./../types";

const state = {
  isModalOpen: false
};

const getters = {
  [types.identity.getters.IS_MODAL_OPEN]: state => {
    return state.isModalOpen;
  }
};

const mutations = {
  [types.identity.mutations.MUTATE_MODAL]: (state, payload) => {
    state.isModalOpen = payload;
  }
};

const actions = {
  [types.identity.actions.SET_MODAL]: ({ commit }, payload) => {
    commit(types.identity.mutations.MUTATE_MODAL, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
